import { Link } from "react-router-dom";
import { characters } from "@/mocks/anime";

export default function CharacterPreview() {
  const preview = characters.slice(0, 3);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
      <div className="flex items-end justify-between gap-3">
        <div>
          <span className="text-sm font-medium text-primary-600">CHARACTERS</span>
          <h2 className="font-heading mt-1 text-2xl text-foreground-900 md:text-3xl">关键角色</h2>
        </div>
        <Link to="/characters" className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer">
          完整角色图鉴
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {preview.map((c) => (
          <article
            key={c.name}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-accent-200"
          >
            <span className="inline-block rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
              {c.badge}
            </span>
            <h3 className="mt-4 text-lg font-medium text-foreground-900">{c.name}</h3>
            <p className="text-sm text-primary-600">{c.role}</p>
            <p className="mt-3 text-sm leading-6 text-foreground-600">{c.desc}</p>
            <p className="mt-4 flex items-center gap-1 text-xs text-secondary-600">
              <i className="ri-double-quotes-l"></i>
              {c.tagline}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}